import { css } from '@emotion/react';
import { PanelHeader } from '@frontend/panel-engine';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';

export const TopBarPanelHeader = ({ title }: { title: string }) => (
  <header
    css={css`
      display: flex;
      justify-content: space-between;
    `}
  >
    <Heading
      level={2}
      css={{ marginBottom: 0, display: 'flex', gap: theme.spacing(2), alignItems: 'center' }}
      data-testid='tray-header'
    >
      {title}
    </Heading>
    <PanelHeader.Close iconName='x' size='large' />
  </header>
);

export const TopBarPanelContent = ({ children }: { children: React.ReactNode }) => (
  <div
    css={css`
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: auto;
      flex-grow: 1;
    `}
  >
    {children}
  </div>
);
